
import React, { useState, useEffect } from 'react';

export const FloatingContactButton: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const handleClick = () => {
    window.open('https://ws.formzu.net/dist/S835655639/', '_blank', 'noopener,noreferrer');
  };

  return (
    <>
      {isVisible && (
        <button
          onClick={handleClick}
          className="fixed bottom-6 right-6 z-50 bg-pink-600 hover:bg-pink-700 text-white px-4 py-3 rounded-full shadow-lg transition-all duration-300 transform hover:scale-105 flex items-center space-x-2 whitespace-nowrap"
          style={{ 
            animation: 'fadeInUp 0.3s ease-out',
            boxShadow: '0 4px 20px rgba(236, 72, 153, 0.3)'
          }}
        >
          <i className="ri-mail-send-fill text-lg"></i>
          <span className="font-semibold text-sm sm:text-base">お問い合わせはこちら</span>
        </button>
      )}
      
      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </>
  );
};